import jp from 'jsonpath';
import getFormLocal from './getFormLocal';

export default async function getValue(formId, path) {
  const form = await getFormLocal(formId);
  try {
    return jp.query(form, path);
  } catch (e) {
    console.log('Error get value');
    return null;
  }
}
